import { useEffect } from "react";
import { useActivityMenu } from "../hooks/useActivityMenu";
import { useKeyboardShortcuts } from "../hooks/useKeyboardShortcuts";
import { isEditableTarget } from "../lib/isEditableTarget";
import { KeyboardShortcutsPanel } from "./KeyboardShortcutsPanel";

export function KeyboardShortcuts() {
  const { open, close, toggle } = useKeyboardShortcuts();
  const { toggle: toggleActivity } = useActivityMenu();
  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.defaultPrevented || event.repeat || event.isComposing) return;
      if (
        (event.metaKey || event.ctrlKey) &&
        !event.shiftKey &&
        !event.altKey &&
        event.key === "j" &&
        !document.querySelector(
          'dialog[open]:not([aria-label="Navigation"]), [role="dialog"]'
        )
      ) {
        event.preventDefault();
        event.stopPropagation();
        toggleActivity();
        return;
      }
      const modifiedSlash =
        (event.metaKey || event.ctrlKey) &&
        !event.shiftKey &&
        !event.altKey &&
        (event.code === "Slash" || event.key === "/");
      const questionMark =
        event.key === "?" &&
        !event.metaKey &&
        !event.ctrlKey &&
        !event.altKey &&
        !isEditableTarget(event);
      if (!modifiedSlash && !questionMark) return;
      if (document.querySelector('dialog[open]:not([aria-label="Navigation"])'))
        return;
      event.preventDefault();
      event.stopPropagation();
      toggle();
    };
    document.addEventListener("keydown", onKeyDown, true);
    return () => document.removeEventListener("keydown", onKeyDown, true);
  }, [toggle, toggleActivity]);

  return <KeyboardShortcutsPanel open={open} onClose={close} />;
}
